<template>
    <b-collapse
        :open="isOpen"
        @close="close"
        @open="open">
        <div
            slot="trigger" 
            :class="{
                trigger: true,
                'is-active': isOpen,
            }">
            <b-icon
                size="is-small"
                :icon="isOpen ? 'minus' : 'plus'"
            ></b-icon>
            <slot name="title"></slot>
        </div>
        <div
            v-if="level == null"
            class="content">
            <slot></slot>
        </div>
        <section-item
            v-else
            :key="i"
            v-for="(section, i) of sections"
            :level="null">
            <template slot="title">{{ section.title }}</template>
            <div v-html="section.content"></div>
        </section-item>
    </b-collapse>
</template>

<script>
import SectionItem from "./SectionItem.vue";

export default Vue.extend({
  name: "section-item",
  components: {
    SectionItem
  },
  props: {
    level: {
      type: Number,
      default: 1
    },
    content: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      sectionIndices: [],
      sections: []
    };
  },
  created() {
    this.sectionIndices = this.getSectionIndices();

    for (let i in this.sectionIndices) {
      this.sections.push(this.getSection(i));
    }
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    getSectionCount() {
      if (!this.level) {
        return 0;
      }

      return _.filter(this.$slots.default, { tag: `h${this.level}` }).length;
    },
    getSectionIndices() {
      if (!this.level) {
        return [];
      }

      let offset = 0;
      let indices = [];

      while (true) {
        let index = _.findIndex(
          this.$slots.default,
          { tag: `h${this.level}` },
          offset
        );

        if (index == -1) {
          break;
        }

        indices.push(index);
        offset = index + 1;
      }

      return indices;
    },
    createHTMLNode(node) {
      let element;

      if (node.tag) {
        element = document.createElement(node.tag, node.text);
        _.each(_.get(node, "data.attrs", []), (value, name) => {
          element.setAttribute(name, value);
        });
      } else {
        element = document.createTextNode(node.text);
      }

      return element;
    },
    compileHTML(nodes, root = null) {
      if (root == null) {
        root = document.createElement("div");
      }

      for (let node of nodes) {
        let element;

        if (node.children) {
          element = this.compileHTML(node.children, this.createHTMLNode(node));
        } else {
          element = this.createHTMLNode(node);
        }

        root.append(element);
      }

      return root;
    },
    getSection(index) {
      let section = {
        title: _.get(
          this.$slots.default[this.sectionIndices[index]],
          "children.0.text"
        ),
        content: ""
      };

      let content = [];

      let end =
        index < this.sectionIndices.length - 1
          ? this.sectionIndices[Number(index) + 1]
          : this.$slots.default.length;

      for (let i = this.sectionIndices[index] + 1; i < end; i++) {
        content.push(this.$slots.default[i]);
      }

      section.content = this.compileHTML(content).outerHTML;

      return section;
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/help/index/SectionItem.vue